export default __webpack_public_path__ + "static/media/image.c92677c8.png";